module.exports = __webpack_public_path__ + "static/media/do.1504487c.png";